import { render } from "./App.vue?vue&type=template&id=7e75e2c3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7e75e2c3&lang=css"

import exportComponent from "C:\\Cwiczenia Programowanie Wojtek\\Vue Shop-FCC\\lang-cross\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__